import { type Feature } from '../domain/Feature'

export function formatFeatureLabel(feature: Feature) {
  switch (feature) {
    case 'early_appointment':
      return 'Early appointment'
    case 'fast_facility':
      return 'Fast facility'
    case 'palletized':
      return 'Palletized'
    case 'top_rated_facility':
      return 'Top rated facility'
    default:
      return undefined
  }
}
